import gettext from '@sdk/lang/gettext';

export const SCHEDULING_LITE_FEATURE_LIST = [
  gettext('Shift scheduling'),
  gettext('Time off requests'),
  gettext('Available shifts'),
  gettext('News sharing'),
  gettext('Long term scheduling'),
];

export const SCHEDULING_PRO_FEATURE_LIST = [
  gettext('Time tracking'),
  gettext('Labor cost management'),
  gettext('Private and group messaging'),
  gettext('Reports'),
  gettext('PTO tracking'),
];
